import { useQuery } from "react-query";

import { getClinicianNextAppointmentAsync } from "api/clinician";
import { GET_CLINICIAN_NEXT_APPOINTMENT } from "@constants/reactQueryKeys";
import { STALE_TIME_3_MINUTES } from "@constants/reactQueryKeys";

/**
 * This hook is used to get the next appointment for a clinician using a GET request to
 * `/v2/clinician/[clinicianUserId]/next-call` endpoint.
 *
 * @param {string|number} clinicianUserId - The clinician user id.
 * @param {Object} options - The options for the query.
 * @returns {Object} The next appointment data.
 */
export const useGetClinicianNextAppointment = (clinicianUserId, options = {}) => {
  const { data, isLoading, ...rest } = useQuery(
    [GET_CLINICIAN_NEXT_APPOINTMENT, clinicianUserId],
    () => getClinicianNextAppointmentAsync(clinicianUserId),
    {
      enabled: Boolean(clinicianUserId),
      refetchOnWindowFocus: false,
      staleTime: STALE_TIME_3_MINUTES,
      ...options,
    }
  );

  return {
    nextAppointment: data?.data || null,
    nextAppointmentLoading: isLoading,
    ...rest,
  };
};
